import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EventService, JobsService, TaskService } from '../../../../services';
import { JobScreenModelPinTask } from '../../../../interfaces/screen-specific/job-screen';
import { InputHelper } from '../../../../utils/input.helper';

@Component({
  selector: 'job-screen-model-pin',
  templateUrl: './job-screen-model-pin.component.html',
  styleUrls: ['./job-screen-model-pin.component.scss', '../../common/job-screen-common.scss'],
})
export class JobScreenModelPinComponent implements OnInit {
  @Input('jobId') jobId!: number;
  @Input('orderId') orderId!: number;
  @Input('modelPinTask') modelPinTask!: JobScreenModelPinTask;
  @Input('organisationId') organisationId!: number;
  @Input('organisationTypeId') organisationTypeId!: number;

  isShownMoDelPin: boolean;
  public moDelPin: string;

  constructor(
    private eventService: EventService,
    private taskService: TaskService,
    public inputHelper: InputHelper,
  ) {}

  ngOnInit(): void {}

  saveMoDelPin() {
    this.isShownMoDelPin = false;
    this.taskService
      .updateMoDelPin({
        jobId: this.jobId,
        taskId: this.modelPinTask.id,
        moDelPin: this.moDelPin,
      })
      .then((res) => {
        if (res) {
          this.modelPinTask.moDelPin = this.moDelPin;

          this.eventService.JobScreenEvent.emit({
            event: 'refresh-notes',
            data: { jobId: this.jobId },
            sender: 'saveModelPin',
          });
        }
      });
  }

  showMoDelPinDialog() {
    this.moDelPin = this.modelPinTask.moDelPin;
    this.isShownMoDelPin = true;
  }
}
